export enum MONTHS {
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
}

export enum MonthValue {
  'Jan.' = '01',
  'Feb.' = '02',
  'Mar.' = '03',
  'Apr.' = '04',
  'May.' = '05',
  'Jun.' = '06',
  'Jul.' = '07',
  'Aug.' = '08',
  'Sep.' = '09',
  'Oct.' = '10',
  'Nov.' = '11',
  'Dec.' = '12',
}

export function dateToMilliseconds(dateString: string): number {
  // Expected format: "MM/DD/YYYY HH:mm AM/PM"
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})\s+(AM|PM)$/i;
  const match = dateString.match(regex);

  if (!match) {
    throw new Error('Invalid date format received from backend');
  }
  const month = parseInt(match[1], 10) - 1;
  const day = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);
  let hour = parseInt(match[4], 10);
  const minute = parseInt(match[5], 10);
  const ampm = match[6].toUpperCase();
  if (ampm === 'PM' && hour < 12) hour += 12;
  if (ampm === 'AM' && hour === 12) hour = 0;
  return Date.UTC(year, month, day, hour, minute);
}
